import React from 'react';

import { CircularProgress, LinearProgress } from '@material-ui/core';

interface IProps {
  overlayStyle?: React.CSSProperties;
  size?: number;
  style?: React.CSSProperties;
  type?: 'linear';
}

const LoadingPanelLoader: React.FC<IProps> = React.memo((props) => {
  const { overlayStyle, style, type } = props;
  let { size } = props;
  size = size ?? 2;

  if (type === 'linear') {
    return (
      <div className="loading-overlay" style={overlayStyle}>
        <LinearProgress
          variant="indeterminate"
          style={style}
          className="progress-linear-indeterminate"
        />
      </div>
    );
  }
  return (
    <div className="loading-overlay" style={overlayStyle}>
      <CircularProgress
        variant="indeterminate"
        className="progress-circle-indeterminate"
        size={36 * size}
      />
    </div>
  );
});

LoadingPanelLoader.displayName = 'LoadingPanelLoader';

export default LoadingPanelLoader;
